import React from 'react';
import './BartMenu.css';
import SimulatorBart1 from '../images/screenshots/SimulatorBart1.png';
import SimulatorBart2 from '../images/screenshots/SimulatorBart2.png';
import SimulatorBart3 from '../images/screenshots/SimulatorBart3.png';
import AppStoreBadge from '../images/apple/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import BartMenuIcon from '../images/bartmenu-icon.png';

function BartMenu() {
  return (
    <div className="bartmenu">
      <section className="bartmenu-header">
        <div className="page-app-icon">
          <img src={BartMenuIcon} alt="BartMenu app icon" />
        </div>
        <h1>BartMenu</h1>
        <p>Create party menus for your cocktail robot machines</p>
      </section>

      <section className="app-showcase">
        <div className="content-wrapper">
          <div className="app-detail">
            <div className="app-info">
              <div className="app-description">
                <p>
                  BartMenu is a simple menu creation app for cocktail robots like the Bartesian and
                  Bev. It allows you to easily create and print beautiful cocktail menus that 
                  showcase your favorite drinks. Whether you're hosting a party or just want to 
                  impress your friends, BartMenu makes it easy to create and share a professional-looking 
                  menu in minutes.
                </p>
                
                <h3>Key Features</h3>
                <ul>
                  <li><strong>Automatic Download:</strong> New pods released will be automatically added to your app</li>
                  <li><strong>Custom Cocktails:</strong> Add your own cocktails to the menu if the pods aren't available for your favorites</li>
                  <li><strong>Photos:</strong> Use your own cocktail photos for a personal touch</li>
                  <li><strong>Menu Designs:</strong> Print simple lists, detailed menus, or full-color layouts</li>
                  <li><strong>Export Options:</strong> Save as PDF or print directly from the app</li>
                  <li><strong>Cloud Sync:</strong> Access your menus across all your devices</li>
                </ul>

                <h3>Why BartMenu?</h3>
                <p>
                  We built BartMenu because we think cocktail robots are the future of home bartending. 
                  They make it easy to create delicious cocktails with the push of a button, and they 
                  can help you spend less time behind the bar and more time with your guests. But providing
                  a great cocktail experience is about more than just the machine - it's also about the menu. 
                  A well-designed menu can help you showcase your cocktails, guide your guests' choices,
                  and create a memorable experience.
                </p>

                <h3>Perfect For</h3>
                <ul>
                  <li>🎉 <strong>Party Hosts:</strong> Impress guests with professional cocktail menus</li>
                  <li>🍸 <strong>Cocktail Enthusiasts:</strong> Showcase your favorite drinks beautifully</li>
                  <li>🏠 <strong>Home Bars:</strong> Create a restaurant-quality experience at home</li>
                  <li>🎁 <strong>Gift Givers:</strong> Perfect companion for cocktail robot owners</li>
                </ul>

                <div className="app-store-section">
                  <p className="availability">Available now in the App Store</p>
                  <div className="app-store-badge">
                    <a href="https://apps.apple.com/us/app/bartmenu/id6753362022">
                      <img src={AppStoreBadge} alt="Download on the App Store" className="app-store-image" />
                    </a>
                  </div>
                </div>

                <div className="responsible-drinking-notice">
                  <h3>🍷 Please Drink Responsibly</h3>
                  <p>
                    BartMenu is designed to enhance your entertaining experience. If you or someone you know 
                    is struggling with alcohol dependency, help is available.
                  </p>
                  <a href="/drink-responsibly" className="help-resources-link">
                    View Help Resources & Support
                  </a>
                </div>
              </div>
            </div>

            <div className="app-screenshots">
              <h3>Screenshots</h3>
              <div className="screenshots-grid">
                <div className="screenshot-item">
                  <img src={SimulatorBart1} alt="BartMenu Home Screen" />
                  <p>Home Screen</p>
                </div>
                <div className="screenshot-item">
                  <img src={SimulatorBart2} alt="BartMenu Cocktail Selection" />
                  <p>Cocktail Selection</p>
                </div>
                <div className="screenshot-item">
                  <img src={SimulatorBart3} alt="BartMenu Menu Designs" />
                  <p>Menu Designs</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BartMenu;
